import {FieldsEnum} from 'api/v2';

// Values match the API's ResourceFlag.Field choices; order matches the
// resource form.
export const FLAG_FIELD_OPTIONS: Array<{value: FieldsEnum; label: string}> = [
  {value: FieldsEnum.title, label: 'Title'},
  {value: FieldsEnum.subtitle, label: 'Subtitle'},
  {value: FieldsEnum.description, label: 'Description'},
  {value: FieldsEnum.collections, label: 'Categories'},
  {value: FieldsEnum.email, label: 'Email'},
  {value: FieldsEnum.phone_number, label: 'Phone'},
  {value: FieldsEnum.website, label: 'Website'},
  {value: FieldsEnum.date_time_information, label: 'Date & Time Information'},
  {value: FieldsEnum.location, label: 'Address'},
  {value: FieldsEnum.other, label: 'Something else'},
];
